import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import CorpList from './corp-list';
import CorpListStore from './corp-list-store';

const CorpListContainer = () => {
  // console.log('CorpListContainer Load');

  const { userList, totalInfo } = CorpListStore;
  const [selectedData, setSelectedData] = useState([]);

  useEffect(() => {
    // console.log('CorpListContainer > useEffect()');

    CorpListStore.getUserList();
  }, []);

  const onSelectionChanged = useCallback(({ selectedRowsData }) => {
    setSelectedData(selectedRowsData);
  }, []);

  const onClickUseInfo = useCallback(async () => {
    const result = await CorpListStore.getUseInfoList('', 3);

    if (result.error) {
      alert(result.message);
    }
  }, []);

  const onClickExcelRegisterFile = useCallback(() => {
    CorpListStore.setVisibleExcelRegisterFilePopup(true);
    
  }, []);

  const onClickSelectedInfo = useCallback(() => {
    if (selectedData.length === 0) {
      alert('체크박스를 선택해 주시기 바랍니다.');
      return;
    }

    CorpListStore.setVisibleSelectedInfoPopup(true, selectedData);
  }, [selectedData]);

  const onClickUserDetailInfo = useCallback((data, mode) => {
    CorpListStore.setVisibleDetailInfoPopup(true, data, mode);
  }, []);

  if (!userList) {
    return;
  }

  return (
    <CorpList
      onSelectionChanged={onSelectionChanged}
      onClickUseInfo={onClickUseInfo}
      onClickExcelRegisterFile={onClickExcelRegisterFile}
      onClickUserDetailInfo={onClickUserDetailInfo}
      onClickSelectedInfo={onClickSelectedInfo}
      userList={userList}
      totalInfo={totalInfo}
    />
  );
};

export default React.memo(observer(CorpListContainer));
